var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20C39 30.4934 30.4934 39 20 39C9.50659 39 1 30.4934 1 20C1 9.50659 9.50659 1 20 1C30.4934 1 39 9.50659 39 20Z",
    fill: "#E3C8AA",
    stroke: "#071524",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4436 9L21.1454 16.4527L23.0605 12.0606L31.4436 9Z",
    fill: "#E17726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58032 9.00876L16.941 12.0611L18.7594 16.5108L8.58032 9.00876Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2994 24.8497L31.8511 24.9345L30.2604 30.2198L24.7064 28.7242L27.2994 24.8497Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7006 24.8497L15.2841 28.7242L9.73938 30.2199L8.15833 24.9345L12.7006 24.8497Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5122 15.3773L18.6983 21.2533L13.1323 21.0056L14.7155 18.6695L14.7355 18.647L18.5122 15.3773Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4301 15.3118L25.2645 18.6473L25.2843 18.6696L26.8675 21.0057L21.3028 21.2533L21.4301 15.3118Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.447 24.8668L18.4862 27.1828L14.9558 28.8499L15.447 24.8668Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5535 24.8664L25.0346 28.8499L21.514 27.1826L24.5535 24.8664Z",
    fill: "#E27625"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5917 26.9645L25.1642 28.6564L21.841 30.2011L21.8755 29.1801L21.5917 26.9645Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4073 26.9652L18.1346 29.1634L18.157 30.1999L14.826 28.6564L18.4073 26.9652Z",
    fill: "#D5BFB2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3757 22.0202L18.3093 23.9391L15.1308 23.0285L17.3757 22.0202Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6242 22.0204L24.8797 23.0284L21.6909 23.9388L22.6242 22.0204Z",
    fill: "#233447"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69 24.8472L15.1762 28.977L12.4225 24.9375L15.69 24.8472Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3102 24.8472L27.5778 24.9375L24.8138 28.9771L24.3102 24.8472Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.948 20.7721L24.57 23.1425L22.7366 22.323L21.8588 24.1279L21.2833 21.0242L26.948 20.7721Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0508 20.7721L18.7165 21.0242L18.1411 24.1278L17.2631 22.3232L15.4393 23.1425L13.0508 20.7721Z",
    fill: "#CC6228"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8905 20.2857L15.581 22.9559L15.6742 25.5919L12.8905 20.2857Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1122 20.2809L24.3235 25.5965L24.4285 22.9558L27.1122 20.2809Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.585 20.4483L18.6933 21.1149L18.9609 22.7755L18.7888 27.8759L17.9755 23.7787L17.9753 23.7364L18.585 20.4483Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4135 20.4391L22.0249 23.7363L22.0246 23.7787L21.2093 27.8862L21.177 26.8588L21.0498 22.7453L21.4135 20.4391Z",
    fill: "#E27525"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6677 22.8497L24.5766 25.14L21.7384 27.3028L21.1647 26.9063L21.8078 23.6663L24.6677 22.8497Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3422 22.8498L18.1922 23.6664L18.8353 26.9063L18.2616 27.3028L15.4232 25.1398L15.3422 22.8498Z",
    fill: "#F5841F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2829 28.1506L17.914 29.8333L17.8987 29.1148L18.2025 28.854H21.7963L22.1111 29.1139L22.0879 29.832L25.696 28.1549L23.9403 29.5738L21.8173 31H18.1734L16.0517 29.568L14.2829 28.1506Z",
    fill: "#C0AC9D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3315 26.7405L21.8449 27.0952L22.1458 29.443L21.7104 29.0834H18.2908L17.8637 29.4502L18.1547 27.0954L18.6683 26.7405H21.3315Z",
    fill: "#161616"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7638 9.2063L32 12.8334L31.228 16.5008L31.7777 16.9156L31.0338 17.4706L31.5929 17.8929L30.8526 18.5523L31.3071 18.8742L30.1009 20.252L25.1538 18.8432L25.1109 18.8207L21.5458 15.8794L30.7638 9.2063Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23619 9.2063L18.4542 15.8794L14.8892 18.8207L14.8463 18.8432L9.89907 20.252L8.69293 18.8742L9.14706 18.5526L8.40711 17.8929L8.96511 17.4711L8.21013 16.9144L8.78059 16.4994L8 12.8336L9.23619 9.2063Z",
    fill: "#763E1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9117 18.5351L30.1536 20.0277L31.8566 25.1612L27.3637 25.1612L24.268 25.1994L26.5193 20.9074L24.9117 18.5351Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0883 18.5351L13.4804 20.9074L15.732 25.1994L12.6378 25.1612H8.15289L9.84633 20.0278L15.0883 18.5351Z",
    fill: "#F5841F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3173 12.0361L21.8511 15.9091L21.5399 21.1411L21.4209 22.781L21.4114 26.9702H18.5885L18.5793 22.7888L18.4599 21.1397L18.1486 15.9091L16.6827 12.0361H23.3173Z",
    fill: "#F5841F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4409_31314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 1C50.4934 1 59 9.50659 59 20C59 30.4934 50.4934 39 40 39C29.5066 39 21 30.4934 21 20C21 9.50659 29.5066 1 40 1Z",
    fill: "url(#paint0_linear_4409_31314)",
    stroke: "#071524",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1033 11.25C29.5035 11.25 29.2724 11.9917 29.7757 12.3015L42.3666 19.8934C42.6805 20.0866 43.099 20.0103 43.3151 19.7204L48.851 12.4527C49.2274 11.9479 48.8471 11.25 48.1956 11.25H30.1033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8926 28.75C50.4923 28.75 50.7294 28.0043 50.2262 27.6946L37.6317 20.1036C37.3178 19.9104 36.9094 19.9964 36.6933 20.2863L31.1467 27.5525C30.7704 28.0573 31.1626 28.75 31.814 28.75H49.8926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4409_31314",
    x1: 20,
    y1: 0,
    x2: 67.2645,
    y2: 27.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255CE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4409_31314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallets);
export default __webpack_public_path__ + "static/media/wallets.9eeeab586f46800595319abfdebca677.svg";
export { ForwardRef as ReactComponent };